import React, { createContext, useState, useCallback, useEffect } from 'react';
const Context = createContext(undefined);
export const TextInputContextProvider = ({ children }) => {
    const [tools, setTools] = useState([]);
    const [editor, setEditor] = useState(null);
    const [lastSelection, setLastSelection] = useState(null);
    const [isEmpty, setIsEmpty] = useState(true);
    const toggleTool = useCallback((tool, cb) => {
        const next = tools.includes(tool)
            ? tools.filter((v) => v !== tool)
            : [...tools, tool];
        setTools(next);
        if (cb)
            cb(next);
    }, [tools]);
    useEffect(() => {
        if (!editor)
            return;
        const isEmpty = () => {
            setIsEmpty(editor.getText().trim().length === 0);
        };
        isEmpty();
        editor.on('text-change', isEmpty);
        return () => {
            editor.off('text-change', isEmpty);
        };
    }, [editor]);
    return (React.createElement(Context.Provider, { value: {
            tools,
            setTools,
            toggleTool,
            editor,
            setEditor,
            lastSelection,
            setLastSelection,
            isEmpty,
            setIsEmpty
        } }, children));
};
export { Context as TextInputContext };
//# sourceMappingURL=TextInputContext.js.map